import store from "../store/store";
export const TECHNICIAN_APPOINTMENT_DASHBOARD_PAGE = "technician-appointment-dashboard-page";
export const TECHNICIAN_APPOINTMENT_DETAILS_PAGE = "technician-appointment-details-page";
export const VEHICLE_ASSET_DETAILS_PAGE = "vehicle-asset-details-page";
export const CONTACT_DETAILS_PAGE = "contact-details-page";

export const RESHEDULE_SLOTS_PAGE = "reschedule-slots-page";
export const RESHEDULE_REQUEST_OVERVIEW_PAGE = "reschedule-request-overview-page";
export const RESHEDULE_BOOKING_CONFIRMATION_PAGE = "reschedule-booking-confirmation-page";
export const RESHEDULE_ADDITIONAL_DETAILS_REQUIRED_PAGE = "reschedule-additional-details-required-page";
export const RESCHEDULE_REASONS_PAGE = "reschedule-reasons-page";

export const SHEDULE_SLOTS_PAGE = "schedule-slots-page";
export const SHEDULE_REQUEST_OVERVIEW_PAGE = "schedule-request-overview-page";
export const SHEDULE_BOOKING_CONFIRMATION_PAGE = "schedule-booking-confirmation-page";
export const SHEDULE_ADDITIONAL_DETAILS_REQUIRED_PAGE = "schedule-additional-details-required-page";

export const VEHICLE_ASSET_DETAILS_ASSISTANCE_REQUIRED_PAGE = "vehicle-asset-details-assistance-required-page";
export const SHEDULE_REQUEST_OVERVIEW_ASSISTANCE_REQUIRED_PAGE = "schedule-request-overview-assistance-required-page";
export const REQUEST_SUBMITTED_ASSISTANCE_REQUIRED_PAGE = "request-submitted-assistance-required-page";

export const VEHICLE_ASSET_DETAILS_10HOURS_DURATION_PAGE = "vehicle-asset-details-10hours-duration-page";
export const CONTACT_DETAILS_10HOURS_DURATION_PAGE = "contact-details-10hours-duration-page";
export const SHEDULE_REQUEST_OVERVIEW_10HOURS_DURATION_PAGE = "schedule-request-overview-10hours-duration-page";
export const REQUEST_SUBMITTED_10HOURS_DURATION_PAGE = "request-submitted-10hours-duration-page";

export const getPendoIdPrefix = () => {
  const sourcewellGovernment = store.getState().ACCOUNT.isSourcewellGovernment ? "-govt-sourcewell" : "";
  return `cfst${sourcewellGovernment}`;
};
export const getPendoId = (id) => {
  const currentPage = store.getState().TECHNICIANAPPOINTMENT.currentPage || "";
  return `${getPendoIdPrefix()}-${currentPage}-${id}`;
};

/**
 * Dispatches the current page to the Redux store based on the step and conditions.
 * @param {number} step - The current step.
 * @param {number} subStep - The current substep (if applicable).
 * @param {boolean} isReschedule - Whether the flow is a reschedule flow.
 * @param {boolean} isAssistanceRequired - Whether assistance is required.
 * @param {boolean} isJobDurationExceeds10Hrs - Whether the job duration exceeds 10 hours.
 * @param {boolean} isScheduleApiFailed - Whether the schedule API call failed.
 */
export const findCurrentPage = (step, subStep, isReschedule, isAssistanceRequired, isJobDurationExceeds10Hrs, isScheduleApiFailed) => {
  let currentPage = "";

  switch (step) {
    case 1:
      if (isReschedule) {
        // Reschedule Flow: Substep 0 -> SLOTS_PAGE, Substep 1 -> RESCHEDULE_REASONS_PAGE
        currentPage = subStep === 0 ? RESHEDULE_SLOTS_PAGE : RESCHEDULE_REASONS_PAGE;
      } else {
        // Normal Flow: VEHICLE_ASSET_DETAILS_PAGE
        if (isAssistanceRequired) {
          currentPage = VEHICLE_ASSET_DETAILS_ASSISTANCE_REQUIRED_PAGE;
        } else if (isJobDurationExceeds10Hrs) {
          currentPage = VEHICLE_ASSET_DETAILS_10HOURS_DURATION_PAGE;
        } else {
          currentPage = VEHICLE_ASSET_DETAILS_PAGE;
        }
      }
      break;

    case 2:
      if (isReschedule) {
        // Reschedule Flow: REQUEST_OVERVIEW_PAGE
        currentPage = RESHEDULE_REQUEST_OVERVIEW_PAGE;
      } else {
        // Normal Flow: REQUEST_OVERVIEW_PAGE if assistance is required, otherwise CONTACT_DETAILS_PAGE
        if (isAssistanceRequired) {
          currentPage = SHEDULE_REQUEST_OVERVIEW_ASSISTANCE_REQUIRED_PAGE;
        } else if (isJobDurationExceeds10Hrs) {
          currentPage = CONTACT_DETAILS_10HOURS_DURATION_PAGE;
        } else {
          currentPage = CONTACT_DETAILS_PAGE;
        }
      }
      break;

    case 3:
      if (isReschedule) {
        // Reschedule Flow: ADDITIONAL_DETAILS_REQUIRED_PAGE if schedule API failed, otherwise BOOKING_CONFIRMATION_PAGE
        currentPage = isScheduleApiFailed ? RESHEDULE_ADDITIONAL_DETAILS_REQUIRED_PAGE : RESHEDULE_BOOKING_CONFIRMATION_PAGE;
      } else {
        // Normal Flow:
        // REQUEST_SUBMITTED_ASSISTANCE_REQUIRED_PAGE if assistance is required,
        // SHEDULE_REQUEST_OVERVIEW_10HOURS_DURATION_PAGE if job duration exceeds 10 hours,
        // Otherwise SHEDULE_SLOTS_PAGE
        if (isAssistanceRequired) {
          currentPage = REQUEST_SUBMITTED_ASSISTANCE_REQUIRED_PAGE;
        } else if (isJobDurationExceeds10Hrs) {
          currentPage = SHEDULE_REQUEST_OVERVIEW_10HOURS_DURATION_PAGE;
        } else {
          currentPage = SHEDULE_SLOTS_PAGE;
        }
      }
      break;

    case 4:
      // Normal Flow:
      // REQUEST_SUBMITTED_10HOURS_DURATION_PAGE if job duration exceeds 10 hours,
      // Otherwise REQUEST_OVERVIEW_PAGE
      currentPage = isJobDurationExceeds10Hrs ? REQUEST_SUBMITTED_10HOURS_DURATION_PAGE : SHEDULE_REQUEST_OVERVIEW_PAGE;
      break;

    case 5:
      // Normal Flow:
      // ADDITIONAL_DETAILS_REQUIRED_PAGE if schedule API failed,
      // Otherwise BOOKING_CONFIRMATION_PAGE
      currentPage = isScheduleApiFailed ? SHEDULE_ADDITIONAL_DETAILS_REQUIRED_PAGE : SHEDULE_BOOKING_CONFIRMATION_PAGE;
      break;

    default:
      // Default case: No specific page
      currentPage = TECHNICIAN_APPOINTMENT_DASHBOARD_PAGE;
      break;
  }
  return currentPage;
  // Dispatch the action to update the current page in the store
  // dispatch(setCurrentPage(currentPage));
};

// This function retrieves the current page label based on the pendoId.
export const getPageLabel = () => {
  const currentPage = store.getState().TECHNICIANAPPOINTMENT.currentPage || "";
  const pendoLabels = {
    [TECHNICIAN_APPOINTMENT_DASHBOARD_PAGE]: formatLabel(TECHNICIAN_APPOINTMENT_DASHBOARD_PAGE),
    [TECHNICIAN_APPOINTMENT_DETAILS_PAGE]: formatLabel(TECHNICIAN_APPOINTMENT_DETAILS_PAGE),
    [VEHICLE_ASSET_DETAILS_PAGE]: formatLabel(VEHICLE_ASSET_DETAILS_PAGE),
    [CONTACT_DETAILS_PAGE]: formatLabel(CONTACT_DETAILS_PAGE),
    [RESHEDULE_SLOTS_PAGE]: formatLabel(RESHEDULE_SLOTS_PAGE),
    [RESHEDULE_REQUEST_OVERVIEW_PAGE]: formatLabel(RESHEDULE_REQUEST_OVERVIEW_PAGE),
    [RESHEDULE_BOOKING_CONFIRMATION_PAGE]: formatLabel(RESHEDULE_BOOKING_CONFIRMATION_PAGE),
    [RESHEDULE_ADDITIONAL_DETAILS_REQUIRED_PAGE]: formatLabel(RESHEDULE_ADDITIONAL_DETAILS_REQUIRED_PAGE),
    [RESCHEDULE_REASONS_PAGE]: formatLabel(RESCHEDULE_REASONS_PAGE),
    [SHEDULE_SLOTS_PAGE]: formatLabel(SHEDULE_SLOTS_PAGE),
    [SHEDULE_REQUEST_OVERVIEW_PAGE]: formatLabel(SHEDULE_REQUEST_OVERVIEW_PAGE),
    [SHEDULE_BOOKING_CONFIRMATION_PAGE]: formatLabel(SHEDULE_BOOKING_CONFIRMATION_PAGE),
    [SHEDULE_ADDITIONAL_DETAILS_REQUIRED_PAGE]: formatLabel(SHEDULE_ADDITIONAL_DETAILS_REQUIRED_PAGE),
    [VEHICLE_ASSET_DETAILS_ASSISTANCE_REQUIRED_PAGE]: formatLabel(VEHICLE_ASSET_DETAILS_ASSISTANCE_REQUIRED_PAGE),
    [SHEDULE_REQUEST_OVERVIEW_ASSISTANCE_REQUIRED_PAGE]: formatLabel(SHEDULE_REQUEST_OVERVIEW_ASSISTANCE_REQUIRED_PAGE),
    [REQUEST_SUBMITTED_ASSISTANCE_REQUIRED_PAGE]: formatLabel(REQUEST_SUBMITTED_ASSISTANCE_REQUIRED_PAGE),
    [VEHICLE_ASSET_DETAILS_10HOURS_DURATION_PAGE]: formatLabel(VEHICLE_ASSET_DETAILS_10HOURS_DURATION_PAGE),
    [CONTACT_DETAILS_10HOURS_DURATION_PAGE]: formatLabel(CONTACT_DETAILS_10HOURS_DURATION_PAGE),
    [SHEDULE_REQUEST_OVERVIEW_10HOURS_DURATION_PAGE]: formatLabel(SHEDULE_REQUEST_OVERVIEW_10HOURS_DURATION_PAGE),
    [REQUEST_SUBMITTED_10HOURS_DURATION_PAGE]: formatLabel(REQUEST_SUBMITTED_10HOURS_DURATION_PAGE),
  };

  return pendoLabels[currentPage] || "Unknown Page"; // Return the label or a default value
};

function formatLabel(key) {
  return key.replace(/-/g, " "); // Replace hyphens with spaces
}
